(function () {
    'use strict';

    function deleteRequestForProposalModalController($scope, $uibModalInstance, notifyService, requestForProposalDataService,
        rfpId) {
        $scope.ok = function () {
            requestForProposalDataService.deleteRequestForProposal(rfpId).then(
                function() {
                    notifyService.notify('This RFP has been deleted');
                });
            $uibModalInstance.close(true);
        };

        $scope.cancel = function() {
            $uibModalInstance.close();
        }
    }

    deleteRequestForProposalModalController.$inject = ['$scope', '$uibModalInstance', 'notifyService',
        'requestForProposalDataService', 'rfpId'];

    angular.module('ecap.requestForProposal').controller('deleteRequestForProposalModalController', deleteRequestForProposalModalController);
})();
